import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo, useEffect, useState } from 'preact/hooks'
import { productImagePlaceholder, imageResizer, productTagBuilder } from "../helpers"

export default function Product({ product, key, index }) {
    const [ swatches, setSwatches ] = useState([]);
    const [ currentProductSwatchImg, setCurrentProductSwatchImg ] = useState('');
    const { format } = useCurrencyFormatting()
    const hasAltImages = useMemo(() => product.alternateImageUrls && product.alternateImageUrls.length > 0, []);
    let hoverClass = "on-hover-img";
    if(!hasAltImages) { hoverClass = "" };
    
    const productTag = useMemo(() => productTagBuilder(product.tags1), [])

    useEffect(() => {
        let productCustomFields = product.customFields;
        productCustomFields.forEach(customField => {
            if (customField.key == "custom-collection_color_swatch_image") {
                const SHOPIFY_STOREFRONT_ACCESS_TOKEN = 'cd891bf7a144ebb793436e0e3f308b2b';
                const SHOPIFY_STORE_URL = 'https://gruntstyle.myshopify.com/';
                
                const graphqlQuery = `
                    query {
                    node(id: ${JSON.stringify(customField.value)}) {
                        ... on MediaImage {
                        id
                        image {
                            originalSrc
                            altText
                            width
                            height
                        }
                        }
                    }
                    }
                `;
                
                const fetchOptions = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_ACCESS_TOKEN,
                  },
                  body: JSON.stringify({ query: graphqlQuery }),
                };
                
                async function fetchShopifyData() {
                  try {
                    const response = await fetch(`${SHOPIFY_STORE_URL}api/2023-07/graphql.json`, fetchOptions);
                    // console.log('Response status:', response.status);
                    
                    if (!response.ok) {
                      throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    
                    const data = await response.json();
                    // console.log('Response data:', JSON.stringify(data, null, 2));
                    
                    if (data.data && data.data.node) {
                        // console.log("new query data", data);
                        const mediaImage = data.data.node;
                        setCurrentProductSwatchImg(mediaImage.image.originalSrc);
                    }
                  } catch (error) {
                    console.error('Error fetching data:', error.message);
                  }
                }
                fetchShopifyData();
            } 
        })
    }, [])

    useEffect(() => {
        let swatchImgsArray = [];

        // check if the product has any custom fields for the img and make the needed query
        // for each product, we automatically make a query that returns it's custom fields
        const query = `
            query {
                product(id: ${JSON.stringify(product.productId)}) {
                    attributes {
                        key
                        value
                    }
                }
            }
        `
    
        let productCustomFields;
        fetch('https://api.nosto.com/v1/graphql', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/graphql',
                'Authorization': 'Basic ' + btoa(":" + "jR7vp6dbT1G9oTCYIrkAT29zUusVWoVLPAw1DNDcDJmRhNkyBMevUSVNxjtrZiYh")
            }),
            mode: 'cors',
            body: query
        })
        .then((response) => response.json())
        // once we have the custom fields, we then are checking for the field 'custom product swatches', 
        // that contains shopify meta objects which also include the nosto product id
        .then(json => {
            productCustomFields = json;
            const productFieldsArray = productCustomFields?.data?.product?.attributes;
            let siblingProducts = [];
            productFieldsArray.forEach(obj => {
                if (obj.key == 'custom-product_swatches') {
                    siblingProducts = JSON.parse(obj.value)
                }
            })
            // with the array of sibling product shopify metaobjects, we turn them into regular product ids and make another query
            siblingProducts.forEach(siblingProduct => {
                const productId = siblingProduct.split("gid://shopify/Product/")[1];
                const query = `
                    query {
                        product(id: ${JSON.stringify(productId)}) {
                            url
                            availability
                            attributes {
                                key
                                value
                            }
                        }
                    }
                `
                fetch('https://api.nosto.com/v1/graphql', {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/graphql',
                        'Authorization': 'Basic ' + btoa(":" + "jR7vp6dbT1G9oTCYIrkAT29zUusVWoVLPAw1DNDcDJmRhNkyBMevUSVNxjtrZiYh")
                    }),
                    mode: 'cors',
                    body: query
                })
                .then((response) => response.json())
                .then(json => {
                    let siblingProductCustomFields = json;
                    const siblingProductFieldsArray = siblingProductCustomFields?.data?.product?.attributes;
                    siblingProductFieldsArray.forEach(sObj => {
                        if (sObj.key == 'custom-collection_color_swatch_hex_code') {
                            const swatchInfo = {};
                            swatchInfo.swatchImgSrc = false;
                            swatchInfo.hexValue = sObj.value;
                            swatchInfo.productId = productId;
                            swatchInfo.url = siblingProductCustomFields?.data?.product?.url;
                            swatchInfo.path = swatchInfo.url.split('/products/')[1].split('?')[0];
                            swatchInfo.availability = siblingProductCustomFields?.data?.product?.availability;
                            setSwatches(prevSwatches => [...prevSwatches, swatchInfo])
                        } else if (sObj.key == 'custom-collection_color_swatch_image') {
                            const swatchInfo = {};
                            swatchInfo.hexValue = false;

                            // make a similar shopify storefront api call in order to find swatchInfo.swatchImgSrc
                            const SHOPIFY_STOREFRONT_ACCESS_TOKEN = 'cd891bf7a144ebb793436e0e3f308b2b';
                            const SHOPIFY_STORE_URL = 'https://gruntstyle.myshopify.com/';
                            
                            const graphqlQuery = `
                                query {
                                node(id: ${JSON.stringify(sObj.value)}) {
                                    ... on MediaImage {
                                    id
                                    image {
                                        originalSrc
                                        altText
                                        width
                                        height
                                    }
                                    }
                                }
                                }
                            `;
                            
                            const fetchOptions = {
                              method: 'POST',
                              headers: {
                                'Content-Type': 'application/json',
                                'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_ACCESS_TOKEN,
                              },
                              body: JSON.stringify({ query: graphqlQuery }),
                            };
                            
                            async function fetchShopifyDataB() {
                              try {
                                const response = await fetch(`${SHOPIFY_STORE_URL}api/2023-07/graphql.json`, fetchOptions);
                                // console.log('Response status:', response.status);
                                
                                if (!response.ok) {
                                  throw new Error(`HTTP error! status: ${response.status}`);
                                }
                                
                                const data = await response.json();
                                // console.log('Response data:', JSON.stringify(data, null, 2));
                                
                                if (data.data && data.data.node) {
                                    const mediaImage = data.data.node;
                                    swatchInfo.swatchImgSrc = mediaImage.image.originalSrc;
                                    swatchInfo.productId = productId;
                                    swatchInfo.url = siblingProductCustomFields?.data?.product?.url;
                                    swatchInfo.path = swatchInfo.url.split('/products/')[1].split('?')[0];
                                    swatchInfo.availability = siblingProductCustomFields?.data?.product?.availability;
                                    setSwatches(prevSwatches => [...prevSwatches, swatchInfo])
                                }
                              } catch (error) {
                                console.error('Error fetching data:', error.message);
                              }
                            }
                            fetchShopifyDataB();
                        }
                    })
                })
            })
        })
    }, [])

    let atLeastOneAvailable = false;
    let firstSwatch = true;
    let swatchCount = 0;
    // console.log("swatches", swatches, index);

    return (
        <SerpElement
            as="a"
            hit={product}
            class="product-card-item ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit ns-col-12 ns-col-xs-6 ns-col-l-3 ns-p-2 ns-my-2 ns-mx-0"
        >
            <div class="product-background-enabled product-card">
                <div class={`product-card-img product-img ${hoverClass}`}>
                    <div class="media" style="--imageRatio:100.0%">
                        <img
                            class="ns-w-100 ns-h-auto"
                            src={imageResizer(product.imageUrl, "350") ?? productImagePlaceholder}
                            alt={product.name}
                            width="600"
                            height="400"
                        />
                    </div>
                    {hasAltImages && (
                        <div class="product-second-img">
                            <img
                                class="ns-w-100 ns-h-auto"
                                src={imageResizer(product.alternateImageUrls[0], "350") ?? productImagePlaceholder}
                                alt={product.name}
                                width="600"
                                height="400"
                            />
                        </div>
                    )}
                    {productTag &&
                        <div class="product-card-badges">
                                <span class='product-badge custom-badge fadein-active'>{productTag}</span>
                        </div>                            
                    }
                </div>
                <div class="ns-relative product-card-detail" data-nosto-element="product">
                    <div class="swatches-container">
                    {swatches && swatches.length > 0 && product?.customFields?.map((customField, index) => {
                        // this is only for rendering the products current swatch
                        if (customField?.key === 'custom-collection_color_swatch_hex_code') {
                            return (
                                <span 
                                    key={index}
                                    className="collection-swatch-img first-swatch" 
                                    style={{backgroundColor: customField?.value}} 
                                    data-swatch="" 
                                    href={product.url} 
                                    data-quick-add={product.productId} 
                                    data-quick-add-handle={product.path} 
                                    data-quick-add-item-url="" 
                                    role="group"
                                />
                            );
                        } else if (customField?.key === 'custom-collection_color_swatch_image') {
                            return (
                                <button 
                                    key={index}
                                    className="collection-swatch-img first-swatch" 
                                    data-swatch="" 
                                    href={product.url} 
                                    data-quick-add={product.productId} 
                                    data-quick-add-handle={product.path} 
                                    data-quick-add-item-url="" 
                                    role="group"
                                >
                                    <img 
                                        // alt={product.path} 
                                        src={currentProductSwatchImg} 
                                        class="collection-swatch-img"
                                    />
                                </button>
                            );
                        }
                        return null;
                    })}
                    {swatches && swatches.length > 0 && swatches.map((swatch, index) => {
                        if(swatch.availability == "InStock" && swatchCount < 4 && !swatch.path.includes("pack")) {
                            swatchCount = swatchCount + 1;
                            if (swatch.hexValue) {
                                return (
                                    <span 
                                    key={index + 1} 
                                    class="collection-swatch-img second-swatch" 
                                    style={{backgroundColor: swatch.hexValue}} 
                                    data-swatch="" 
                                    href={swatch.url} 
                                    data-quick-add={swatch.productId} 
                                    data-quick-add-handle={swatch.path} 
                                    data-quick-add-availability={swatch.availability == "InStock" ? 'true' : 'false'} 
                                    data-quick-add-item-url="" 
                                    role="group"
                                    >
                                    </span>
                                )
                            } else if (swatch.swatchImgSrc) {
                                return (
                                    <button 
                                        key={index + 1} 
                                        class="collection-swatch-img second-swatch" 
                                        data-swatch="" 
                                        href={swatch.url} 
                                        data-quick-add={swatch.productId} 
                                        data-quick-add-handle={swatch.path} 
                                        data-quick-add-availability={swatch.availability == "InStock" ? 'true' : 'false'} 
                                        data-quick-add-item-url="" 
                                        role="group"
                                    >
                                        <img 
                                            alt={swatch.path}
                                            src={swatch.swatchImgSrc} 
                                            class="collection-swatch-img second-swatch"
                                        />
                                    </button>
                                )
                            } 
                        }
                        if(swatchCount == 4 && index >= 4) {
                            swatchCount = swatchCount + 1; 
                            return (
                                <button 
                                    key={index + 1} 
                                    class="collection-swatch-img extra-swatch" 
                                    href={product.url} 
                                    role="group"
                                    style="position:relative;"
                                >
                                    <img 
                                        alt="See More"
                                        src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-12583447/onsiteContent/17255008310580.17289873654379884" 
                                        class="collection-swatch-img extra-swatch"
                                        style="position:absolute;top:-1px;left:-1px;background:#fff"
                                    />
                                </button>
                            )
                        }
                    })}
                    </div>
                    <div class="product-title nosto-product-title">{product.name}</div>
                    <div class="product-price">
                        <span class="price-item actual-price">{format(product.price)}</span>
                        {product.listPrice && product.listPrice > product.price && (
                            <span class="price-item compare-price">
                                {format(product.listPrice)}
                            </span>
                        )}
                    </div>
                    <div class="product-quickview-button">
                        {product.availability == "InStock" ?
                            <a href={product.url} data-quick-view-availability="true" class="product-quickview button btn-block" tabindex="-1" aria-label=" quick view link" data-quick-view="">
                                <span>Quick Add</span>
                            </a>
                        :
                            <a href={product.url} data-quick-view-availability="true" class="product-quickview button btn-block qa-sold-out" tabindex="-1" aria-label=" quick view link" data-quick-view="">
                                <span>SOLD OUT</span>
                            </a>
                        }
                    </div>
                </div>
            </div>
        </SerpElement>
    )
}
